<div
  #modalContents
  class="l-modal03__contents js-modal-contents"
  aria-modal="true"
  role="dialog"
  aria-labelledby="search-flight-history-select-modal-title"
  [ngClass]="{ 'l-modal03__contents--gray': this.SearchFlightHistoryViewList.length === 0 }"
>
  <div #modalHead class="l-modal03__header js-modal-head">
    <div class="p-modal-head01">
      <h1
        id="search-flight-history-select-modal-title"
        class="p-modal-head01__title"
        [innerHTML]="(historyType === 'history' ? 'label.searchHistory.title' : 'label.Favorite.title') | staticMsg"
      ></h1>
      <div
        class="p-modal-head01__side"
        *ngIf="this.SearchFlightHistoryViewList && this.SearchFlightHistoryViewList.length !== 0"
      >
        <button
          id="search-flight-history-select-modal-button-1"
          class="c-btn-edit"
          (click)="changeMode($event)"
          [innerHTML]="
            (mode === HstFvtModeEnum.reference ? 'label.deleteFavorite.initialMode' : 'label.deleteFavorite.deleteMode')
              | staticMsg
          "
          [ngClass]="{ 'c-btn-edit--done': mode === HstFvtModeEnum.delete }"
        ></button>
      </div>
      <button
        id="search-flight-history-select-modal-button-2"
        class="p-modal-head01__close js-modal-close"
        (click)="closeModal($event)"
      >
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>
  <div #modalBody class="l-modal03__body js-modal-body">
    <ng-container
      *ngIf="
        apiFetchState === 'failed' || (apiFetchState === 'complete' && this.SearchFlightHistoryViewList.length === 0)
      "
    >
      <div class="p-modal-body01">
        <ng-container *ngIf="historyType === 'history'">
          <p class="c-enclosure-text" [innerHTML]="'label.noHistoryItem' | staticMsg"></p>
        </ng-container>
        <ng-container *ngIf="historyType === 'favorite'">
          <p class="c-enclosure-text" [innerHTML]="'label.noFavoriteItem' | staticMsg"></p>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="apiFetchState === 'calling'">
      <asw-search-flight-rules-loadding [index]="index"></asw-search-flight-rules-loadding>
    </ng-container>
    <ng-container *ngIf="apiFetchState === 'complete' && this.SearchFlightHistoryViewList.length > 0">
      <ng-container *ngIf="historyType === 'favorite'">
        <div class="c-modal-guidance" role="alert" aria-live="polite">
          <p class="c-modal-guidance__message">
            <em class="c-modal-guidance__text" [innerHTML]="'label.datesNotSaved' | staticMsg"></em>
          </p>
        </div>
      </ng-container>
      <ul class="c-history-list">
        <ng-container *ngFor="let SearchFlightHistory of this.SearchFlightHistoryViewList; index as historyIndex">
          <li class="c-history-list__item">
            <asw-search-flight-history-select-modal-item
              [historyType]="this.historyType"
              [mode]="this.mode"
              (clickItem)="clickHistoryButton($event, historyIndex)"
            >
              <div class="c-history-list__head">
                <span
                  *ngIf="historyType === 'history'"
                  class="u-visually-hidden"
                  [innerHTML]="'reader.historyItemNumber' | staticMsg : { '0': historyIndex + 1 }"
                ></span>
                <span
                  *ngIf="historyType === 'favorite'"
                  class="u-visually-hidden"
                  [innerHTML]="'reader.favoriteItemNumber' | staticMsg : { '0': historyIndex + 1 }"
                ></span>
                <p
                  class="c-history-list__head-text"
                  [innerHTML]="
                    (SearchFlightHistory.roundTripFlag ? 'label.roundTripSelect' : 'label.onewayOrMultiCitySelect')
                      | staticMsg
                  "
                ></p>
              </div>
              <!-- 往復旅程かつ旅程の説明が1行-->
              <ng-container
                *ngIf="
                  SearchFlightHistory.roundTripFlag &&
                  SearchFlightHistory.roundTrip !== null &&
                  !SearchFlightHistory.roundTrip.isMultiLine
                "
              >
                <div class="c-history-list__body">
                  <div class="c-history-list__unit">
                    <p class="c-history-list__text-m">
                      <span class="c-history-list__fromto">
                        <span class="c-history-list__fromto-item"
                          >{{ SearchFlightHistory.roundTrip.originLocationName
                          }}<span class="c-history-list__fromto-separator"
                            ><span class="u-visually-hidden" [innerHTML]="'reader.to' | staticMsg"></span
                            ><span aria-hidden="true" [innerHTML]="'label.symbolBetweenTime' | staticMsg"></span></span
                        ></span>
                        <span class="c-history-list__fromto-item">{{
                          SearchFlightHistory.roundTrip.destinationLocationName
                        }}</span>
                      </span>
                    </p>
                    <ng-container
                      *ngIf="
                        historyType === 'history' &&
                        (SearchFlightHistory.roundTrip.departureDate || SearchFlightHistory.roundTrip.returnDate)
                      "
                    >
                      <p class="c-history-list__text-m">
                        <span class="c-history-list__fromto">
                          <span class="c-history-list__fromto-item"
                            >{{ SearchFlightHistory.roundTrip.departureDate
                            }}<span class="c-history-list__fromto-separator"
                              ><span class="u-visually-hidden" [innerHTML]="'reader.to' | staticMsg"></span
                              ><span
                                aria-hidden="true"
                                [innerHTML]="'label.symbolBetweenTime' | staticMsg"
                              ></span></span
                          ></span>
                          <span class="c-history-list__fromto-item">{{
                            SearchFlightHistory.roundTrip.returnDate
                          }}</span>
                        </span>
                      </p>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
              <!-- 往復旅程かつ旅程の説明が複数行-->
              <ng-container
                *ngIf="
                  SearchFlightHistory.roundTripFlag &&
                  SearchFlightHistory.roundTrip !== null &&
                  SearchFlightHistory.roundTrip.isMultiLine
                "
              >
                <div class="c-history-list__body">
                  <div class="c-history-list__unit">
                    <p class="c-history-list__text-m">
                      <span class="c-history-list__fromto">
                        <span class="c-history-list__fromto-item"
                          >{{ SearchFlightHistory.roundTrip.originLocationName
                          }}<span class="c-history-list__fromto-separator"
                            ><span class="u-visually-hidden" [innerHTML]="'reader.to' | staticMsg"></span
                            ><span aria-hidden="true" [innerHTML]="'label.symbolBetweenTime' | staticMsg"></span></span
                        ></span>
                        <span class="c-history-list__fromto-item">{{
                          SearchFlightHistory.roundTrip.destinationLocationName
                        }}</span>
                      </span>
                    </p>
                    <ng-container *ngIf="historyType === 'history'">
                      <p class="c-history-list__text-m">
                        {{ SearchFlightHistory.roundTrip.departureDate }}
                      </p>
                    </ng-container>
                    <ul class="c-history-list__condition-list" *ngIf="SearchFlightHistory.fare.isMixedCabin">
                      <li class="c-history-list__condition-list-item">
                        {{ SearchFlightHistory.fare.mixedCabinClasses.departureCabinClassName }}
                      </li>
                    </ul>
                    <ul class="c-history-list__transit-list">
                      <li
                        *ngIf="
                          SearchFlightHistory.roundTrip.departureTimeWindowFrom &&
                          SearchFlightHistory.roundTrip.departureTimeWindowTo
                        "
                        class="c-history-list__transit-list-item"
                        [innerHTML]="
                          'labal.originDepartureTime'
                            | staticMsg
                              : {
                                  '0': SearchFlightHistory.roundTrip.departureTimeWindowFromName,
                                  '1': SearchFlightHistory.roundTrip.departureTimeWindowToName
                                }
                        "
                      ></li>
                      <li
                        *ngIf="SearchFlightHistory.roundTrip.departureConnectionLocation"
                        class="c-history-list__transit-list-item"
                        [innerHTML]="
                          ('label.transferconditionAir' | staticMsg) +
                          ' ' +
                          SearchFlightHistory.roundTrip.departureConnectionLocationName
                        "
                      ></li>
                      <li
                        *ngIf="SearchFlightHistory.roundTrip.departureConnectionTime"
                        class="c-history-list__transit-list-item"
                        [innerHTML]="
                          'label.lowestTransferconditionHoursAndMinutes'
                            | staticMsg
                              : {
                                  '0': SearchFlightHistory.roundTrip.departureConnectionTimeHour,
                                  '1': SearchFlightHistory.roundTrip.departureConnectionTimeMinutes
                                }
                        "
                      ></li>
                    </ul>
                  </div>
                  <div class="c-history-list__unit">
                    <p class="c-history-list__text-m">
                      <span class="c-history-list__fromto">
                        <span class="c-history-list__fromto-item"
                          >{{ SearchFlightHistory.roundTrip.destinationLocationName
                          }}<span class="c-history-list__fromto-separator"
                            ><span class="u-visually-hidden" [innerHTML]="'reader.to' | staticMsg"></span
                            ><span aria-hidden="true" [innerHTML]="'label.symbolBetweenTime' | staticMsg"></span></span
                        ></span>
                        <span class="c-history-list__fromto-item">{{
                          SearchFlightHistory.roundTrip.originLocationName
                        }}</span>
                      </span>
                    </p>
                    <ng-container *ngIf="historyType === 'history'">
                      <p class="c-history-list__text-m">
                        {{ SearchFlightHistory.roundTrip.returnDate }}
                      </p>
                    </ng-container>
                    <ul class="c-history-list__condition-list" *ngIf="SearchFlightHistory.fare.isMixedCabin">
                      <li class="c-history-list__condition-list-item">
                        {{ SearchFlightHistory.fare.mixedCabinClasses.returnCabinClassName }}
                      </li>
                    </ul>
                    <ul class="c-history-list__transit-list">
                      <li
                        *ngIf="
                          SearchFlightHistory.roundTrip.returnTimeWindowFrom &&
                          SearchFlightHistory.roundTrip.returnTimeWindowTo
                        "
                        class="c-history-list__transit-list-item"
                        [innerHTML]="
                          'labal.destinationDepartureTime'
                            | staticMsg
                              : {
                                  '0': SearchFlightHistory.roundTrip.returnTimeWindowFromName,
                                  '1': SearchFlightHistory.roundTrip.returnTimeWindowToName
                                }
                        "
                      ></li>
                      <li
                        *ngIf="SearchFlightHistory.roundTrip.returnConnectionLocation"
                        class="c-history-list__transit-list-item"
                        [innerHTML]="
                          ('label.transferconditionAir' | staticMsg) +
                          ' ' +
                          SearchFlightHistory.roundTrip.returnConnectionLocationName
                        "
                      ></li>
                      <li
                        *ngIf="SearchFlightHistory.roundTrip.returnConnectionTime"
                        class="c-history-list__transit-list-item"
                        [innerHTML]="
                          'label.lowestTransferconditionHoursAndMinutes'
                            | staticMsg
                              : {
                                  '0': SearchFlightHistory.roundTrip.returnConnectionTimeHour,
                                  '1': SearchFlightHistory.roundTrip.returnConnectionTimeMinutes
                                }
                        "
                      ></li>
                    </ul>
                  </div>
                </div>
              </ng-container>
              <!-- 複雑旅程-->
              <ng-container
                *ngIf="
                  !SearchFlightHistory.roundTripFlag &&
                  SearchFlightHistory.bounds !== null &&
                  SearchFlightHistory.bounds.length >= 1
                "
              >
                <div class="c-history-list__body">
                  <ng-container *ngFor="let bound of SearchFlightHistory.bounds; index as boundIndex">
                    <div class="c-history-list__unit">
                      <p class="c-history-list__text-m">
                        <span class="c-history-list__fromto">
                          <span class="c-history-list__fromto-item"
                            >{{ bound.originLocationName
                            }}<span class="c-history-list__fromto-separator"
                              ><span class="u-visually-hidden" [innerHTML]="'reader.to' | staticMsg"></span
                              ><span
                                aria-hidden="true"
                                [innerHTML]="'label.symbolBetweenTime' | staticMsg"
                              ></span></span
                          ></span>
                          <span class="c-history-list__fromto-item">{{ bound.destinationLocationName }}</span>
                        </span>
                      </p>
                      <ng-container *ngIf="historyType === 'history'">
                        <p class="c-history-list__text-m">{{ bound.departureDate }}</p>
                      </ng-container>
                      <ul class="c-history-list__condition-list">
                        <ng-container *ngIf="SearchFlightHistory.fare.isMixedCabin">
                          <li *ngIf="boundIndex === 0" class="c-history-list__condition-list-item">
                            {{ SearchFlightHistory.fare.mixedCabinClasses.departureCabinClassName }}
                          </li>
                          <li *ngIf="boundIndex === 1" class="c-history-list__condition-list-item">
                            {{ SearchFlightHistory.fare.mixedCabinClasses.returnCabinClassName }}
                          </li>
                        </ng-container>
                      </ul>
                      <ul
                        class="c-history-list__transit-list"
                        *ngIf="bound.departureTimeWindowFrom && bound.departureTimeWindowTo"
                      >
                        <li
                          class="c-history-list__transit-list-item"
                          [innerHTML]="
                            'labal.ComplexdepartureTime'
                              | staticMsg
                                : { '0': bound.departureTimeWindowFromName, '1': bound.departureTimeWindowToName }
                          "
                        ></li>
                      </ul>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
              <div class="c-history-list__foot">
                <ul class="c-history-list__condition-list">
                  <ng-container *ngIf="!SearchFlightHistory.fare.isMixedCabin">
                    <li class="c-history-list__condition-list-item">{{ SearchFlightHistory.fare.cabinClassName }}</li>
                  </ng-container>
                  <li class="c-history-list__condition-list-item">
                    {{ SearchFlightHistory.travelers.displayText }}
                  </li>
                  <li
                    *ngIf="SearchFlightHistory.promotionCode"
                    class="c-history-list__condition-list-item"
                    [innerHTML]="('label.promotionCode' | staticMsg) + ' ' + SearchFlightHistory.promotionCode"
                  ></li>
                </ul>
              </div>
              <ng-container *ngIf="mode === HstFvtModeEnum.delete">
                <div class="c-history-list__delete" (click)="clickHistoryDeleteButton($event, historyIndex)">
                  <img
                    src="assets/images/icon_delete_red_24.svg"
                    width="24"
                    height="24"
                    alt="{{ 'alt.deleteFavorite' | staticMsg }}"
                  />
                  <span
                    class="u-visually-hidden"
                    [innerHTML]="
                      (historyType === 'history' ? 'reader.history.delete' : 'reader.favorite.delete')
                        | staticMsg : { '0': historyIndex + 1 }
                    "
                  ></span>
                </div>
              </ng-container>
            </asw-search-flight-history-select-modal-item>
            <ng-container *ngIf="historyType === 'history'">
              <div class="c-history-list__favorite">
                <ng-container *ngIf="SearchFlightHistory.isFavoriteAdded">
                  <p class="c-history-list__favorite-added" [innerHTML]="'label.favoriteAdded' | staticMsg"></p>
                </ng-container>
                <ng-container *ngIf="!SearchFlightHistory.isFavoriteAdded && mode === HstFvtModeEnum.reference">
                  <div
                    class="c-history-list__favorite-favorite-icon"
                    (throttleClick$)="clickHistoryAddFavoriteButton($event, historyIndex)"
                    tabindex="0"
                    aswThrottleClick
                  >
                    <img
                      src="assets/images/icon_addtofavorite_24.svg"
                      width="24"
                      height="24"
                      alt="{{ 'alt.history.addToFavorite' | staticMsg }}"
                    />
                    <span
                      class="u-visually-hidden"
                      [innerHTML]="'reader.history.addToFavorite' | staticMsg : { '0': historyIndex + 1 }"
                    ></span>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </li>
        </ng-container>
      </ul>
    </ng-container>
  </div>
</div>
